import styled from 'styled-components';

import { basicSmallTextStyle, RowDetails } from '@dreryk/react-components';

export const StyledP1PrescriptionRowDetails = styled(RowDetails)`
   ${basicSmallTextStyle};
`;
StyledP1PrescriptionRowDetails.displayName = 'StyledP1PrescriptionRowDetails';
